// extracted by mini-css-extract-plugin
export var trainImage = "train-module--trainImage--8FlX+";